import { ChevronDown, LogOut, UserRound } from 'lucide-react'
import { useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Avatar } from '@/components/ui'
import { useLogout } from '@/features/auth/hooks/useAuthMutations'
import { useOnClickOutside } from '@/hooks/useOnClickOutside'
import { useAuthStore } from '@/stores/authStore'
import { cn } from '@/utils/cn'

export function UserMenu() {
  const user = useAuthStore((state) => state.user)
  const logout = useLogout()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)
  useOnClickOutside(ref, () => setOpen(false), open)

  if (!user) return null

  const primaryRole = user.papeis[0]?.replace(/_/g, ' ') ?? 'COLABORADOR'

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((value) => !value)}
        aria-haspopup="menu"
        aria-expanded={open}
        className="flex items-center gap-2 rounded-lg p-1 pr-2 text-left hover:bg-surface-2"
      >
        <Avatar name={user.nomeColaborador} size="sm" />
        <span className="hidden min-w-0 sm:block">
          <span className="block truncate text-sm font-medium text-fg">{user.nomeColaborador}</span>
          <span className="block truncate text-xs capitalize text-fg-muted">
            {primaryRole.toLowerCase()}
          </span>
        </span>
        <ChevronDown
          className={cn('size-4 text-fg-subtle transition-transform', open && 'rotate-180')}
        />
      </button>

      {open && (
        <div
          role="menu"
          className="pc-animate-modal absolute right-0 z-40 mt-2 w-52 origin-top-right overflow-hidden rounded-xl border border-line bg-surface py-1 shadow-lg"
        >
          <Link
            to="/meu-perfil"
            role="menuitem"
            onClick={() => setOpen(false)}
            className="flex items-center gap-2.5 px-3 py-2 text-sm text-fg hover:bg-surface-2"
          >
            <UserRound className="size-4 text-fg-muted" />
            Meu perfil
          </Link>
          <button
            type="button"
            role="menuitem"
            onClick={() => {
              setOpen(false)
              logout.mutate(undefined, { onSettled: () => navigate('/login', { replace: true }) })
            }}
            className="flex w-full items-center gap-2.5 px-3 py-2 text-sm text-critical hover:bg-critical/8"
          >
            <LogOut className="size-4" />
            Sair
          </button>
        </div>
      )}
    </div>
  )
}
